var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.77458 19.4604C7.8696 19.4604 8.75729 18.5727 8.75729 17.4777C8.75729 16.3826 7.8696 15.495 6.77458 15.495C5.67956 15.495 4.79187 16.3826 4.79187 17.4777C4.79187 18.5727 5.67956 19.4604 6.77458 19.4604Z",
    fill: "#CED5EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0705 19.4604C28.1655 19.4604 29.0532 18.5727 29.0532 17.4777C29.0532 16.3826 28.1655 15.495 27.0705 15.495C25.9754 15.495 25.0877 16.3826 25.0877 17.4777C25.0877 18.5727 25.9754 19.4604 27.0705 19.4604Z",
    fill: "#CED5EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4289 19.5755C13.5969 19.5755 10.7317 21.4397 10.7317 24.3633C10.7317 25.1118 11.3384 25.7185 12.0869 25.7185C12.8353 25.7185 13.4421 25.1118 13.4421 24.3633C13.4421 23.4958 14.4654 22.2859 16.4289 22.2859C18.3923 22.2859 19.4156 23.4958 19.4156 24.3633C19.4156 25.1118 20.0224 25.7185 20.7708 25.7185C21.5193 25.7185 22.126 25.1118 22.126 24.3633C22.126 21.4397 19.2608 19.5755 16.4289 19.5755Z",
    fill: "#CED5EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7031 16.4248C32.7031 25.2614 25.5397 32.4248 16.7031 32.4248C7.86657 32.4248 0.703125 25.2614 0.703125 16.4248C0.703125 7.58825 7.86657 0.424805 16.7031 0.424805C25.5397 0.424805 32.7031 7.58825 32.7031 16.4248ZM16.7031 30.8248C24.656 30.8248 31.1031 24.3777 31.1031 16.4248C31.1031 8.4719 24.656 2.0248 16.7031 2.0248C8.75022 2.0248 2.30312 8.4719 2.30312 16.4248C2.30312 24.3777 8.75022 30.8248 16.7031 30.8248Z",
    fill: "#CED5EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBad);
export default __webpack_public_path__ + "static/media/bad.87c06d4f0beeccbe7766db26b4aa8239.svg";
export { ForwardRef as ReactComponent };